










































/* General */
import Vue from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */
import MastheadInput from '@/components/global/inputs/masthead-input.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { AccountRoles } from '@/types/defined-types'
import {
  ICompaniesInputCreate,
  ICompaniesInputCreateInvitee,
} from '@/api/types/request.types'
import { IItemForSelection } from '@/api/types/response.types'

/* API */
import CompaniesAPI from '@/api/modules/companies.api'

export default Vue.extend({
  name: 'CompanyCreate',

  metaInfo: {
    title: 'Create Company',
  },

  components: {
    CardCanvas,
    MastheadInput,
  },

  data() {
    return {
      isSubmitting: false,
      AccountRoles,
      RouteAssistant,
      invalidEmailRows: [] as number[],
      formData: {
        name: '',
        sendInvitations: true,
        /* Stub with a default invitee */
        listInvitees: [
          {
            email: '',
            accountRoleID: 4,
          },
          {
            email: '',
            accountRoleID: 4,
          },
          {
            email: '',
            accountRoleID: 4,
          },
        ],
      } as ICompaniesInputCreate,
    }
  },

  computed: {
    lastInvitee(): ICompaniesInputCreateInvitee {
      return this.formData.listInvitees[this.formData.listInvitees.length - 1]
    },
    availableRoles(): IItemForSelection[] {
      return this.$permissions.availableRolesToAdmin
    },
    submitLabel(): string {
      if (this.formData.listInvitees.filter(i => i.email !== '').length > 0) {
        return 'Create Company & Send Invites'
      }

      return 'Create Company'
    },
    disableSubmit(): boolean {
      return !(
        this.formData.name.trim() !== '' && this.invalidEmailRows.length === 0
      )
    },
  },

  methods: {
    addRow(): void {
      /* Stub new row with blank email but carryover other columns */
      this.formData.listInvitees.push({
        email: '',
        accountRoleID: this.lastInvitee.accountRoleID,
      })
    },
    addInvalidEmailIndex(index: number) {
      // Add the index from the invalid list...
      if (this.invalidEmailRows.includes(index)) {
        return
      }
      this.invalidEmailRows.push(index)
    },
    addValidEmailIndex(index: number) {
      // Remove the index from the invalid list...
      if (this.invalidEmailRows.includes(index)) {
        this.invalidEmailRows = this.invalidEmailRows.filter(e => e !== index)
      }
    },
    async createCompany() {
      this.isSubmitting = true
      try {
        const response = await CompaniesAPI.post_Create(this.formData)
        this.$messaging.showSuccess(response.message)
        RouteAssistant.goToPeople(this.$router, this.$route.params.accountId)
      } catch (error) {
        this.$error.emit(error, true)
      }
      this.isSubmitting = false
    },
  },
})
